import { PermissionKey, PermissionScope } from "@fitness-app/data-models";

import { usePermission } from "~/hooks/usePermission";

/**
 * Czy zadanie założone dla klientki ma trafić do JEJ trenerki, czy do autora.
 *
 * Warunek był pisany po roli (`isOwner` / `isTrainer`), więc administracja
 * operacyjna zakładająca zadanie klientce przypisywała je sobie zamiast
 * trenerce — a to ona jest odbiorcą. Pyta o to samo, co przypisanie trenerki
 * w profilu klientki: prawo pisania po klientkach spoza własnego przydziału.
 */
export const useCanRouteTaskToClientTrainer = (): boolean =>
  usePermission(PermissionKey.CLIENTS_WRITE, PermissionScope.TEAM);
